// @core/api/endpoints/audittrail/list_audit_records_by_actor.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditRecordsResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List audit records by actor
 * Returns all audit records for actions performed by a specific actor.
 */
export async function ListAuditRecordsByActor(
  actor_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditRecordsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/actors/:actor_id/records`;
  requestPath = requestPath.replace(':actor_id', encodeURIComponent(actor_id));
  const requestOptions = options;
  return client.get<ListAuditRecordsResponse>(requestPath, { ...requestOptions, params });
}
